module.exports = __webpack_public_path__ + "static/media/A1_Sports_DRAGON_BLACK.7c3a9ca5.png";